// src/data/categories.js
// Firestore CRUD for the `hub_categories` collection — SUPER-admin-managed
// custom Hub categories (extra dashboard tabs like "HR"). The four built-in
// categories (Sales, Product, Internal Tools, Third Party Tools) live in
// src/config/categories.js and are NOT stored here.
//
// ⚠️ The shared meltplan-website Firestore already owns a `categories`
// collection (the marketing site's blog categories). To avoid colliding with
// it, the Hub keeps its custom categories in a SEPARATE `hub_categories`
// collection.
//
// Doc id = category key (slug). Doc shape:
//   { key: string, label: string, order: number, createdBy: string, createdAt }

import {
  collection,
  doc,
  setDoc,
  updateDoc,
  deleteDoc,
  onSnapshot,
  serverTimestamp,
} from 'firebase/firestore';
import { db } from '../firebase';

const HUB_CATEGORIES_COLLECTION = 'hub_categories';

// Subscribe to the custom category list. Calls cb with an array of
// { id, key, label, order, ... }. Returns an unsubscribe function. `onError`
// (optional) is called if the listener fails (e.g. a permission-denied read);
// without it the failure is swallowed silently.
export function subscribeCategories(cb, onError) {
  return onSnapshot(
    collection(db, HUB_CATEGORIES_COLLECTION),
    (snapshot) => {
      cb(snapshot.docs.map((d) => ({ id: d.id, ...d.data() })));
    },
    (err) => {
      console.error('subscribeCategories failed:', err);
      if (onError) onError(err);
    }
  );
}

// Create a custom category. `key` (slug) is used as the doc id.
export async function addCategory(key, label, order, createdBy) {
  await setDoc(doc(db, HUB_CATEGORIES_COLLECTION, key), {
    key,
    label,
    order: order || 0,
    createdBy: (createdBy || '').toLowerCase(),
    createdAt: serverTimestamp(),
  });
}

// Rename / reorder an existing custom category (key/doc-id is immutable).
export async function updateCategory(key, data) {
  await updateDoc(doc(db, HUB_CATEGORIES_COLLECTION, key), data);
}

export async function deleteCategory(key) {
  await deleteDoc(doc(db, HUB_CATEGORIES_COLLECTION, key));
}
